import { useState } from 'react';
import { t } from 'i18next';
import Modal from '../../../../../components/Modal';
import SelectAsync from '../../../../../components/SelectAsync';
import ApiCore from '../../../../../services/utilities/core';
import OrderEditorModal from '../OrderEditorModal';

const sellers = new ApiCore({ url: '/api/v1/orders/create/sellers' });

type Props = { onClose: () => void; onSaved: () => void };
export default function NewOrderModal({ onClose, onSaved }: Props) {
  const [seller, setSeller] = useState<{value: string; label: string} | null>(null);
  const [started, setStarted] = useState(false);
  if (started && seller) {
    return <OrderEditorModal access="create" sellerCode={seller.value} onClose={onClose} onSaved={onSaved} />;
  }
  return <Modal showModal title={t('newOrder')} closeModal={onClose} actionNameBtn={t('continue')}
    disableActionBtn={!seller} action={() => { if (seller) setStarted(true); }}>
    <div style={{ padding: '1rem' }}>
      <label htmlFor="new-order-seller">{t('selectSeller') as string}</label>
      <SelectAsync id="new-order-seller" request={sellers} value={seller} onChange={setSeller}
        placeholder={t('selectSeller')} debounceTimeout={300}
        reqResponseToOption={{ mapper: {
          value: (item: {CodigoVendedor: string; Nome: string}) => String(item.CodigoVendedor),
          label: (item: {CodigoVendedor: string; Nome: string}) => `${item.CodigoVendedor} - ${item.Nome}`,
        } }} />
    </div>
  </Modal>;
}
